import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import axios from "./plugins/axios";
import "sweetalert2/dist/sweetalert2.min.css";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"; // Keep only this import for SweetAlert2

// Import global styles
import "./assets/styles/global.css";

// Set the base URL for Axios globally
axios.defaults.baseURL = "/api";
//axios.defaults.baseURL = '/api';

// Add a request interceptor to include the token in the headers
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const app = createApp(App);
app.component("VueDatePicker", VueDatePicker);
app.use(vuetify);
app.use(router);
app.use(store);
app.mount("#app");
